import { useState, useEffect, useRef } from "react";
import ActionsDataTable from "../../../shared/DataTable/ActionsDataTable";
import { companyActions } from "../../../redux/actions/company.actions";
import { useDispatch, useSelector } from "react-redux";
import { globalConstants, modeConstants } from "../../../constants";
import AddProjectModal from "../../../shared/Modals/ProjectModal";
import { useNavigate } from "react-router-dom";
import AllProjectModal from "../../../shared/Modals/AllprojectsModal";
import CompanyModal from "./Modal/CompanyModal";
import { projectActions, recruiterActions, screenActions } from "../../../redux/actions";
import { SCREENS_IDS } from "../../../system";
export default function Companies() {
  const initialGridState = {
    length: 10,
    pageNumber: 1,
    orderBy: "id desc",
    filterQuery: null,
    search: null,
    filterExpression: globalConstants.FILTER_EXPRESSION,
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sortingInProgressRef = useRef(false);
  const [showModal, setShowModal] = useState(false);
  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  const [mode, setMode] = useState(modeConstants.ADD_MODE);
  const [selectedRow, setSelectedRow] = useState(null);
  const [rowData, setRowData] = useState({ items: [], total: 0 });
  const allData = useSelector((s) => s.companyReducer.data);
  let isManager = useSelector((s) => s.recruiterReducer.isManager);

  const actions = {
    name: "Actions",
    sortable: false,
    cell: (row) => (

      <div
        className="d-flex align-items-center gap-2"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Edit */}
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          title="Edit"
          aria-label="Edit"
          onClick={() => {
            getRowData(row, modeConstants.UPDATE_MODE);
            setShowModal(true);
          }}
        >
          <i className="bi bi-pencil"></i>
        </button>

        {/* View */}
        <button
          type="button"
          className="btn btn-sm btn-outline-success"
          title="View"
          aria-label="View"
          onClick={() => {
            getRowData(row, modeConstants.VIEW_MODE);
            setShowModal(true);
          }}
        >
          <i className="bi bi-eye"></i>
        </button>

        {/* 3 dots dropdown */}
        <div className="dropdown">
          <button
            className="btn btn-sm btn-outline-secondary"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            title="More"
          >
            <i className="bi bi-three-dots-vertical"></i>
          </button>
          <ul
            className="dropdown-menu dropdown-menu-end"
            onClick={(e) => e.stopPropagation()}
          >
            {!isManager && (
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => addProject(row, modeConstants.ADD_MODE)}
                >
                  <i className="bi bi-plus-circle me-2" /> Add Project
                </button>
              </li>
            )}
            <li>
              <button
                className="dropdown-item"
                onClick={() => viewAllProjects(row)}
              >
                <i className="bi bi-collection me-2" /> View All Projects
              </button>
            </li>
          </ul>
        </div>
      </div>
    ),
    ignoreRowClick: true,
    allowOverflow: true,
    button: true,

  }

  const getRowData = (row, nextMode) => {
    dispatch(companyActions.getCompanyById(row.id));
    setMode(nextMode);
  };

  const toggleStatus = (id) => {
    dispatch(companyActions.deleteCompanyById(id));
  };

  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection
      ? sortDirection.toUpperCase() // "ASC" | "DESC"
      : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection != null ? `${sortedColumn} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  const getAll = () => {
    dispatch(companyActions.getAllCompanies(gridState));
  };
  useEffect(() => {
    if (allData !== null) {
      setRowData(allData);
    }
    // eslint-disable-next-line
  }, [allData]);

  useEffect(() => {
    getAll();
    sortingInProgressRef.current = false;
    // eslint-disable-next-line
  }, [gridState]);

  const [showAddProject, setShowAddProject] = useState(false);
  const [showAllProject, setShowAllProject] = useState(false);

  const addProject = (row, mode) => {
    getRowData(row, mode);
    setShowAddProject(true);
  };

  const viewAllProjects = (row) => {
    getRowData(row);
    dispatch(projectActions.getAllProject(initialGridState, row.id));
    setSelectedRow(row);
    setShowAllProject(true);
  };

    useEffect(() => {
      if (!showAllProject) {
        dispatch(screenActions.getColumnsByScreenId(SCREENS_IDS.COMPANIES));
        dispatch(screenActions.getUserPreferencesByScreenId(SCREENS_IDS.ALL_CANDIDATES));
      }
    }, [showAllProject]);

  return (
    <>
      <CompanyModal
        showModal={showModal}
        setShowModal={setShowModal}
        mode={mode}
      />
      <AddProjectModal
        show={showAddProject}
        onHide={() => setShowAddProject(false)}
        mode={mode}
      />

      {showAllProject && <AllProjectModal
        show={showAllProject}
        onHide={() => setShowAllProject(false)}
        company={selectedRow}
      />}
      
      <ActionsDataTable
        actions={actions}
        data={rowData.items}
        pagination
        highlightOnHover
        striped
        responsive
        persistTableHead
        selectableRows
        selectableRowsHighlight
        selectableRowsVisibleOnly
        setShowModal={setShowModal}
        paginationServer={true}
        onSort={onSort}
        gridState={gridState}
        paginationTotalRows={rowData.total}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onChangePage={onChangePage}
        paginationDefaultPage={defaultPage}
        paginationResetDefaultPage
        setMode={setMode}
        setGridState={setGridState}
        sortServer={true}
        screenId={SCREENS_IDS.COMPANIES}
        toggleStatus={toggleStatus}
      />
    </>
  );
}
